export const MAP_BASE = { lat: 51.828, lng: -1.146, label: "England" };

export const CONNECT_LIVE_COUNTRIES = [
  "Australia",
  "Austria",
  "Belgium",
  "Bulgaria",
  "Canada",
  "China",
  "Czechia",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "India",
  "Ireland",
  "Isle of Man",
  "Italy",
  "Japan",
  "Jersey",
  "Malaysia",
  "Mexico",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Poland",
  "Portugal",
  "Singapore",
  "Spain",
  "Sweden",
  "Thailand",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
];

export const US_OPERATIONAL_STATES = [
  "Alabama",
  "Arizona",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Illinois",
  "Indiana",
  "Kentucky",
  "Louisiana",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "New Jersey",
  "New York",
  "North Carolina",
  "Ohio",
  "Oregon",
  "Tennessee",
  "Texas",
  "Utah",
  "Virginia",
  "Washington",
  "West Virginia",
];

export const AUSTRALIAN_OPERATIONAL_STATES = [
  "New South Wales",
  "Queensland",
  "Western Australia",
];

const COVERAGE_COORDINATES = {
  Wales: { lat: 52.257, lng: -3.16 },
  Scotland: { lat: 56.165, lng: -3.867 },
  "Northern Ireland": { lat: 54.521, lng: -7.072 },
  Ireland: { lat: 53.142, lng: -7.692 },
  "Isle of Man": { lat: 54.236, lng: -4.548 },
  Jersey: { lat: 49.19, lng: -2.11 },
  "New South Wales": { lat: -33.57, lng: 149.415 },
  Queensland: { lat: -23.434, lng: 146.817 },
  "Western Australia": { lat: -27.163, lng: 118.43 },
  Austria: { lat: 47.516, lng: 14.55 },
  Belgium: { lat: 50.504, lng: 4.47 },
  Bulgaria: { lat: 42.734, lng: 25.486 },
  Canada: { lat: 56.13, lng: -106.347 },
  China: { lat: 35.862, lng: 104.195 },
  Czechia: { lat: 49.818, lng: 15.473 },
  Denmark: { lat: 56.264, lng: 9.502 },
  Finland: { lat: 61.924, lng: 25.748 },
  France: { lat: 46.228, lng: 2.214 },
  Germany: { lat: 51.166, lng: 10.452 },
  India: { lat: 20.594, lng: 78.963 },
  Italy: { lat: 41.872, lng: 12.567 },
  Japan: { lat: 36.205, lng: 138.253 },
  Malaysia: { lat: 4.211, lng: 101.976 },
  Mexico: { lat: 23.635, lng: -102.553 },
  Netherlands: { lat: 52.133, lng: 5.291 },
  "New Zealand": { lat: -40.901, lng: 174.886 },
  Norway: { lat: 60.472, lng: 8.469 },
  Poland: { lat: 51.919, lng: 19.145 },
  Portugal: { lat: 39.4, lng: -8.225 },
  Singapore: { lat: 1.352, lng: 103.82 },
  Spain: { lat: 40.464, lng: -3.749 },
  Sweden: { lat: 60.128, lng: 18.644 },
  Thailand: { lat: 15.87, lng: 100.993 },
  "United Arab Emirates": { lat: 23.424, lng: 53.848 },
  Alabama: { lat: 32.807, lng: -86.791 },
  Arizona: { lat: 34.049, lng: -111.094 },
  California: { lat: 36.778, lng: -119.418 },
  Colorado: { lat: 39.55, lng: -105.782 },
  Connecticut: { lat: 41.603, lng: -73.088 },
  Delaware: { lat: 38.91, lng: -75.527 },
  Florida: { lat: 27.665, lng: -81.516 },
  Georgia: { lat: 32.166, lng: -82.9 },
  Illinois: { lat: 40.633, lng: -89.399 },
  Indiana: { lat: 40.267, lng: -86.135 },
  Kentucky: { lat: 37.839, lng: -84.27 },
  Louisiana: { lat: 30.984, lng: -91.962 },
  Maryland: { lat: 39.045, lng: -76.642 },
  Massachusetts: { lat: 42.407, lng: -71.382 },
  Michigan: { lat: 44.315, lng: -85.602 },
  Minnesota: { lat: 46.73, lng: -94.686 },
  "New Jersey": { lat: 40.058, lng: -74.406 },
  "New York": { lat: 42.954, lng: -75.527 },
  "North Carolina": { lat: 35.76, lng: -79.019 },
  Ohio: { lat: 40.417, lng: -82.907 },
  Oregon: { lat: 43.804, lng: -120.554 },
  Tennessee: { lat: 35.518, lng: -86.58 },
  Texas: { lat: 31.969, lng: -99.902 },
  Utah: { lat: 39.321, lng: -111.094 },
  Virginia: { lat: 37.432, lng: -78.657 },
  Washington: { lat: 47.401, lng: -121.491 },
  "West Virginia": { lat: 38.598, lng: -80.455 },
};

export const COVERAGE_LOCATIONS = [
  ...["Wales", "Scotland", "Northern Ireland"].map((label) => ({
    id: label.toLowerCase().replace(/\s+/g, "-"),
    ...COVERAGE_COORDINATES[label],
    label,
  })),
  ...CONNECT_LIVE_COUNTRIES.filter(
    (country) =>
      country !== "Australia" &&
      country !== "United Kingdom" && country !== "United States of America",
  ).map((label) => ({
    id: label.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
    ...COVERAGE_COORDINATES[label],
    label,
  })),
  ...AUSTRALIAN_OPERATIONAL_STATES.map((label) => ({
    id: `australia-${label.toLowerCase().replace(/\s+/g, "-")}`,
    ...COVERAGE_COORDINATES[label],
    label,
  })),
  ...US_OPERATIONAL_STATES.map((label) => ({
    id: `united-states-${label.toLowerCase().replace(/\s+/g, "-")}`,
    ...COVERAGE_COORDINATES[label],
    label,
  })),
];

const INTERNATIONAL_CONNECT_COUNTRIES = CONNECT_LIVE_COUNTRIES.filter(
  (country) =>
    country !== "Australia" &&
    country !== "United Kingdom" && country !== "United States of America",
);

export const OPERATING_COVERAGE_GROUPS = [
  {
    id: "united-kingdom",
    title: "United Kingdom",
    items: ["England", "Wales", "Scotland", "Northern Ireland"],
  },
  {
    id: "united-states",
    title: "United States of America",
    items: US_OPERATIONAL_STATES,
  },
  {
    id: "australia",
    title: "Australia",
    items: AUSTRALIAN_OPERATIONAL_STATES,
  },
  {
    id: "international",
    title: "International coverage",
    items: INTERNATIONAL_CONNECT_COUNTRIES,
  },
];